<template>
    <v-app>
        <VooHeader />
        <!-- <component :is="`style`">
            @media (orientation: landscape) and (min-width: 1200px) { :root {zoom:
            {{ fixSize }} !important;} }</component
        > -->

        <v-main>
            <div class="box">
                <router-view />
            </div>
        </v-main>

        <VooFooter />
    </v-app>
</template>

<script>
import VooHeader from "./components/Header/VooHeader.vue";
import { useHead } from "@vueuse/head";
import VooFooter from "./components/Footer/VooFooter.vue";

export default {
    components: {
        VooHeader,
        VooFooter,
    },

    setup() {
        useHead({
            // meta: [
            //     {
            //         name: "viewport",
            //         content: `width=device-width,initial-scale=${1 / window.devicePixelRatio}`,
            //     },
            // ],
        });
    },

    computed: {
        fixSize: function () {
            return 1 / window.devicePixelRatio;
        },
    },

    name: "App",
};
</script>

<style scoped></style>
